module.exports = __webpack_public_path__ + "static/media/Declaration-of-Status according-to-US-Tax-Principles.08a39e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/Declaration-of-Status according-to-US-Tax-Principles.png
// module id = 739
// module chunks = 0